import service from '@/services/products';

export default {
  setSelectedProduct: ({ commit }, payload) => {
    commit('setSelectedProduct', payload);
  },
  loadProductTableFlat: ({ commit, state }, hideLoading) => {
    if (!hideLoading) commit('setProductTableLoading', true);
    return service
      .getProducts(state.productTable.pagination, state.productTable.mode)
      .then(response => commit('loadProductTableFlat', response));
  },
  loadProductTable: ({ commit, state }, hideLoading) => {
    if (!hideLoading) commit('setProductTableLoading', true);
    return service
      .getProducts(state.productTable.pagination, state.productTable.mode)
      .then(response => commit('loadProductTableIncr', response));
  },
  loadProductTableItem: ({ commit, state }, productId) => {
    return service
      .getProductsItem(state.productTable.pagination, productId)
      .then(response => commit('loadProductTableSuccess', response));
  },
  setProductTableMode({ commit }, payload) {
    commit('setProductTableMode', payload);
  },
  setProductTablePagination({ commit }, payload) {
    return commit('setProductTablePagination', payload);
  },

  resetProductTablePagination({ commit }) {
    return commit('setProductTablePagination', {
      descending: [true],
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
    });
  },
  searchProducts({ commit, state }) {
    return service.searchProducts(state.productSearch.query).then(res => {
      commit('searchProductsSuccess', res);
    });
  },
  moveReview: ({ dispatch, commit }, payload) => {
    return service.moveReview(payload).then(() => {
      commit(
        'showToast',
        {
          color: 'toast_default',
          text: 'Reviews.moveReviews.success',
        },
        { root: true }
      );
      dispatch('reviews/loadReviewsList', null, { root: true });
      dispatch('loadProductTable');
    });
  },
  moveReviews: ({ dispatch, commit }, payload) => {
    return service.moveReviews(payload).then(() => {
      commit(
        'showToast',
        {
          color: 'toast_default',
          text: 'Reviews.moveReviews.success',
        },
        { root: true }
      );
      dispatch('reviews/loadReviewsList', null, { root: true });
    });
  },
};
